import GpioMetadataAdapter from './GpioMetadataAdapter.js'

// One provider instance is shared by all object editors. Components subscribe
// and unsubscribe their own callbacks; they never create a second MQTT listener.
export const gpioMetadataProvider = new GpioMetadataAdapter()

export default gpioMetadataProvider
